import React from 'react';

export default props => <div className="form-control-feedback invalid-feedback" {...props} />;
